import { createFileRoute, redirect } from "@tanstack/react-router";
import { completeCheckoutSession } from "api-client";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { BillingSettingsPage } from "src/pages/BillingSettingsPage";
import {
  billingOverviewQueryOptions,
  billingProductsQueryOptions,
} from "src/queries/billing";

const routeSearchSchema = z.object({
  session_id: z.string().optional(),
});

export const Route = createFileRoute("/_auth/settings/billing")({
  component: BillingSettingsPage,
  ssr: true,
  validateSearch: routeSearchSchema,
  loaderDeps: ({ search }) => {
    return { sessionId: search.session_id };
  },
  loader: async ({ context, deps }) => {
    return loaderHandler(async () => {
      if (deps.sessionId) {
        await completeCheckoutSession({
          body: { sessionId: deps.sessionId },
          throwOnError: false,
        });
        throw redirect({ to: "/settings/billing", replace: true });
      }

      await Promise.all([
        context.queryClient.query({
          ...billingOverviewQueryOptions(),
          staleTime: "static",
        }),
        context.queryClient.query({
          ...billingProductsQueryOptions(),
          staleTime: "static",
        }),
      ]);
      return { data: null };
    });
  },
  staticData: {
    getBreadcrumb(ctx) {
      return {
        href: "/settings/billing",
        label: ctx.i18n.t("billing.title"),
      };
    },
  },
});
